module.exports = __webpack_public_path__ + "img/productRateDescription1.a4e4dfb9.png";